// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"34d306b6","3714":"34d306b6","5266":"4c169a8b","6750":"4ee38821","8470":"9ed2bd69","9355":"34d306b6"}[chunkId] + ".chunk.css";
};